export const GET_MARKETPLACE_HISTORY = 'GET_MARKETPLACE_HISTORY';
export const GET_MARKETPLACE_HISTORY_SUCCESS = 'GET_MARKETPLACE_HISTORY_SUCCESS';
export const GET_MARKETPLACE_HISTORY_ERROR = 'GET_MARKETPLACE_HISTORY_ERROR';

export const GET_AGENTS_HISTORY = 'GET_AGENTS_HISTORY';
export const GET_AGENTS_HISTORY_SUCCESS = 'GET_AGENTS_HISTORY_SUCCESS';
export const GET_AGENTS_HISTORY_ERROR = 'GET_AGENTS_HISTORY_ERROR';
